import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-html-pane',
  templateUrl: './html-pane.component.html',
  styleUrls: ['./html-pane.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true
})

export class HtmlPaneComponent {

  // Caller is responsible for sanitizing input text!
  public htmlText?: string;

}
